import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { useOSDetection } from '@/hooks/detectOS/useOSDetection'

import { MobileOperationSystem } from '@/enums/mobileOperationSystem'
import { PageName } from '@/enums/pageName'
import { CheckoutFlowVersion } from '@/enums/payments'
import { getPath } from '@/utils/urlUtils'

import { PrimaryButton } from '@/components/buttons/primaryButton'
import { TextHTML } from '@/components/typography'
import { GreenEllipse } from '@/shared/icons/GreenEllipse'

import { useAuth } from '@/auth/useAuth'
import { useSession } from '@/core/session/useSession'
import { trackPageView } from '@/events/events'

import { TAlreadyHasAccountPageProps } from './types'

const pageName = PageName.alreadyHasAccount

const redirectToApp = (link: string) => {
  window.open(link)
}

export const AlreadyHasAccountPage = ({
  alreadyHasAccountPage,
  config,
}: TAlreadyHasAccountPageProps) => {
  const { user } = useAuth()
  const sessionContext = useSession()

  const { title, pageTitle, manualSteps, buttonName } = alreadyHasAccountPage

  useEffect(
    () => {
      if (!user && sessionContext.checkoutFlowVersion != CheckoutFlowVersion.V2) {
        return
      }
      trackPageView(
        pageName,
        config.PARTNER_ID,
        config.APP_ID,
        config.PAGE_SET_ID,
        sessionContext,
        user
      )
      document.title = pageTitle ? pageTitle : title
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const mobileOS = useOSDetection()

  if (!user && sessionContext.checkoutFlowVersion != CheckoutFlowVersion.V2) {
    return <Navigate to={getPath(PageName.registration)} replace />
  }

  const className = `page page-${pageName}`

  return (
    <div className={className}>
      <TextHTML className="page-title" title={title} />

      <div className="steps-container">
        {manualSteps.map((step) => {
          return (
            <div className="manual-step" key={step.id}>
              <div className="step-icon">
                <GreenEllipse />
                <div className="step-number">{step.id}</div>
              </div>
              <TextHTML className="text" title={step.title} />
            </div>
          )
        })}
      </div>

      <div className="button-container">
        <PrimaryButton
          type="button"
          onClick={() =>
            redirectToApp(
              mobileOS === MobileOperationSystem.ANDROID
                ? config.APP_GOOGLE_LINK
                : config.APP_APPLE_LINK
            )
          }
        >
          {buttonName}
        </PrimaryButton>
      </div>
    </div>
  )
}
